import template from 'text!./templates/icon.html';
import './icon.scss';


export default () => {


    function link(scope) {

        function setIcon() {
            const commonClasses = ['gw-icon'];
            if (scope.flavour) commonClasses.push(`gw-icon--${scope.flavour}`);
            const isFontAwesome = scope.name.startsWith('fa-');
            scope.icon = {};
            if (!isFontAwesome) {
                scope.icon.classList = commonClasses
                    .concat(['gw-icon--icon-font', `gw-icon--${scope.name}`]).join(' ');
            } else {
                scope.icon.classList = commonClasses
                    .concat(['gw-icon--fa', 'fa', scope.name]).join(' ');
            }
        }

        setIcon();
        scope.$watchGroup(['name', 'flavour'], ([newName, newFlavour], [oldName, oldFlavour]) => {
            if ((newName && newName !== oldName) || newFlavour !== oldFlavour) setIcon();
        });

    }

    return {
        template,
        link,
        replace: true,
        scope: {
            name: '@',
            flavour: '@'
        },
        restrict: 'E'
    };
};
